import { FormField, TextArea } from '@fashionnovateam/nova-ui-toolkit';
import { ExcludeSpecialCharacters } from '../../../Lib/Constants/regexes';
import { ReasonForRequestId } from './formTargetId';
import type { FormErrors, UpdatePurchaseOrderRevisionForm } from './validation';

export function ReasonForRequest({
  reasonForRequest,
  updateForm,
  errors,
  disabled,
}: {
  updateForm: UpdatePurchaseOrderRevisionForm;
  errors: FormErrors | undefined;
  disabled: boolean;
  reasonForRequest: string;
}) {
  return (
    <div className="flex flex-col gap-3 mb-2" id={ReasonForRequestId}>
      <FormField
        required
        error={errors?.reason_for_request}
        label="Reason for Request"
      >
        <TextArea
          value={reasonForRequest}
          rows={4}
          placeholder="e.g., Correcting quantities based on final stock count"
          onChange={(e) => {
            updateForm((prev) => ({
              ...prev,
              reason_for_request: e.target.value.replace(
                ExcludeSpecialCharacters,
                '',
              ),
            }));
          }}
          error={!!errors?.reason_for_request}
          disabled={disabled}
        />
      </FormField>
    </div>
  );
}
